import { render, staticRenderFns } from "./AddCatchingData.vue?vue&type=template&id=f3228ab4&scoped=true&"
import script from "./AddCatchingData.vue?vue&type=script&lang=js&"
export * from "./AddCatchingData.vue?vue&type=script&lang=js&"
import style0 from "./AddCatchingData.vue?vue&type=style&index=0&id=f3228ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3228ab4",
  null
  
)

export default component.exports